import React from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useIntl } from 'react-intl';
import IntroContainer from '../IntroContainer/IntroContainer';

const useStyles = makeStyles({
  title: {
    fontWeight: 'bold',
    marginBottom: 16,
  },
  message: {
    color: '#606B85',
  },
});

export default function GoodbyeScreen() {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <IntroContainer>
      <Typography variant="h5" className={classes.title}>
        {intl.formatMessage({ id: 'zoom.goodbye.title' })}
      </Typography>
      <Typography variant="body1" className={classes.message}>
        {intl.formatMessage({ id: 'zoom.goodbye.message' })}
      </Typography>
    </IntroContainer>
  );
}
